import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {
    Typography, withStyles,
} from "@material-ui/core";
import {ErrorOutline as ErrorIcon} from '@material-ui/icons';
import {Link} from 'react-router-dom';

const styles = theme => ({
    icon: {
        fontSize: 72,
        color: '#FFFFFF',
        marginBottom: theme.spacing.unit*2,
    }
});

class RegisterPush extends PureComponent {

    getError(props = this.props) {
        const {code} = props;

        switch (code) {
            default:
                return {
                    code: 'PUSH_UNKNOWN_ERROR',
                    text: <span>Ett oväntat fel uppstod när vi försökte skicka notifikationer. <Link to="/register">Välj en annan notismetod </Link> för att få tillgång till internet.</span>
                };
            case 'messaging/permission-blocked':
            case 'PUSH_BLOCKED':
                return {
                    code: 'PUSH_BLOCKED',
                    text: <span>Hoppsan, verkar som du valt att blockera våra notifikationer. <Link to="/register">Välj en annan notismetod </Link> för att få tillgång till internet.</span>
                };
            case 'auth/no-uid':
            case 'AUTH_ERROR':
                return {
                    code: 'AUTH_ERROR',
                    text: <span>Ett oväntat fel uppstod när vi verifierade tillåtelse. <Link to="/register">Välj en annan notismetod </Link> för att få tillgång till internet.</span>
                };
            case 'TOKEN_INVALID':
                return {
                    code: 'TOKEN_INVALID',
                    text: <span>Ett oväntat fel uppstod när vi verifierade tillåtelse. <Link to="/register">Välj en annan notismetod </Link> för att få tillgång till internet.</span>
                };
            case 'TOKEN_VERIFY_TIMEOUT':
                return {
                    code: 'TOKEN_VERIFY_TIMEOUT',
                    text: <span>Det tog för lång tid att verifiera tillåtelse. <Link to="/register">Testa igen eller välj en annan notismetod </Link>  för att få tillgång till internet.</span>
                };
        }
    }

    render() {
        const {classes} = this.props;

        const error = this.getError();

        return (
            <React.Fragment>
                <ErrorIcon className={classes.icon} />
                <Typography variant="title" paragraph>
                    Ajdå, någonting gick tyvärr fel
                </Typography>
                <Typography variant="body2">
                    {error.text}
                </Typography>
            </React.Fragment>
        );
    }
}

export default compose(
    withStyles(styles, {withTheme: true}),
)(RegisterPush);



// WEBPACK FOOTER //
// ./src/containers/Register/Error.js